import React, { useEffect, useState } from 'react';
import { Check, Gift, ShoppingCart, Clock, Users, Download } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
function CountdownTimer() {
  const [seconds, setSeconds] = useState(15 * 60);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => s <= 1 ? 15 * 60 : s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = String(Math.floor(seconds / 60)).padStart(2, '0');
  const secs = String(seconds % 60).padStart(2, '0');
  return <div className="bg-red-600 text-white rounded-xl p-4 mb-6 text-center" data-id="element-92">
      <p className="text-sm font-semibold uppercase tracking-wide mb-2 opacity-90" data-id="element-93">
        ⏰ Últimos 15 minutos para que el descuento esté activo
      </p>
      <div className="flex items-center justify-center gap-2" data-id="element-94">
        <div className="bg-red-800 rounded-lg px-4 py-2 min-w-[56px] text-center" data-id="element-95">
          <span className="text-3xl font-extrabold tabular-nums" data-id="element-96">{mins}</span>
          <p className="text-xs opacity-75 mt-0.5" data-id="element-97">MIN</p>
        </div>
        <span className="text-3xl font-extrabold" data-id="element-98">:</span>
        <div className="bg-red-800 rounded-lg px-4 py-2 min-w-[56px] text-center" data-id="element-99">
          <span className="text-3xl font-extrabold tabular-nums" data-id="element-100">{secs}</span>
          <p className="text-xs opacity-75 mt-0.5" data-id="element-101">SEG</p>
        </div>
      </div>
    </div>;
}
export function OfferSection() {
  return <section id="offer" className="py-16 px-4 bg-emerald-50" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="text-center mb-10" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-105">
            Lo Que Recibe Hoy
          </h2>
          <p className="text-xl text-gray-600" data-id="element-106">
            El Protocolo Completo de Limpieza Glicémica de 7 Días
          </p>
        </div>

        <Card variant="highlight" className="max-w-3xl mx-auto relative" data-id="element-107">
          <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 rounded-bl-lg font-bold text-sm uppercase" data-id="element-108">
            50% Descuento
          </div>

          <div className="p-8 md:p-12" data-id="element-109">
            <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-110">
              <div className="w-full md:w-1/3" data-id="element-111">
                <img src="https://cdn.magicpatterns.com/uploads/swco9uh88fgzGaxD6EYQFz/Mockup.png" alt="Pack Completo" className="w-full rounded-lg shadow-md" data-id="element-112" />
              </div>
              <div className="w-full md:w-2/3" data-id="element-113">
                <h3 className="text-2xl font-bold text-emerald-800 mb-4" data-id="element-114">
                  El Protocolo de Limpieza Glicémica
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-115">
                  <li className="flex items-start" data-id="element-116">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-117" />
                    <span className="text-gray-700" data-id="element-118">
                      <strong data-id="element-119">La Guía de las 7 Hierbas Maestras</strong> (valor
                      $1.200)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-120">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-121" />
                    <span className="text-gray-700" data-id="element-122">
                      <strong data-id="element-123">El Truco del Post-Asado</strong> (valor $500)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-124">
                    <Check className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-125" />
                    <span className="text-gray-700" data-id="element-126">
                      <strong data-id="element-127">La Técnica del Movimiento Invisible</strong>{' '}
                      (valor $400)
                    </span>
                  </li>
                </ul>
                <div className="bg-emerald-100 p-4 rounded-lg flex items-center gap-3 mb-2" data-id="element-128">
                  <Gift className="h-6 w-6 text-emerald-700" data-id="element-129" />
                  <p className="text-sm text-emerald-800 font-medium" data-id="element-130">
                    Incluye acceso de por vida y actualizaciones futuras gratis.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8" data-id="element-131">
              <CountdownTimer data-id="element-132" />

              <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300 rounded-xl p-3 mb-6" data-id="element-133">
                <Users className="h-5 w-5 text-amber-600 flex-shrink-0" data-id="element-134" />
                <p className="text-amber-800 font-bold text-sm md:text-base" data-id="element-135">
                  🔥 ¡Últimos 3 cupos disponibles al precio de oferta!
                </p>
              </div>

              <div className="text-center mb-6" data-id="element-136">
                <p className="text-gray-500 line-through text-xl mb-1" data-id="element-137">
                  Precio Normal: $980 UYU
                </p>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-138">
                  <span className="text-5xl md:text-6xl font-extrabold text-gray-900" data-id="element-139">
                    $490
                  </span>
                  <span className="text-2xl font-bold text-gray-600" data-id="element-140">UYU</span>
                  <span className="bg-red-100 text-red-700 text-sm font-bold px-2 py-1 rounded-lg" data-id="element-141">
                    -50%
                  </span>
                </div>
                <p className="text-emerald-700 font-semibold text-sm" data-id="element-142">
                  Precio especial de lanzamiento
                </p>
              </div>

              <div className="flex items-center justify-center gap-2 mb-6 text-gray-600 text-sm" data-id="element-143">
                <Download className="h-4 w-4 text-emerald-600" data-id="element-144" />
                <span className="font-semibold text-emerald-700" data-id="element-145">
                  +1.400 descargas
                </span>
                <span className="text-gray-400" data-id="element-146">·</span>
                <span data-id="element-147">⭐⭐⭐⭐⭐</span>
                <span className="font-semibold" data-id="element-148">4.9/5 promedio</span>
              </div>

              <Button size="xl" fullWidth className="max-w-md mx-auto mb-4 shadow-xl text-lg" data-id="element-149">
                <ShoppingCart className="mr-2 h-6 w-6" data-id="element-150" />
                SÍ, QUIERO MI PROTOCOLO AHORA
              </Button>

              <div className="flex justify-center gap-4 text-xs text-gray-500" data-id="element-151">
                <span data-id="element-152">🔒 Pago 100% Seguro</span>
                <span data-id="element-153">⚡ Descarga Inmediata</span>
                <span data-id="element-154">📧 Envío por Email</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>;
}